import { render, staticRenderFns } from "./IncomeDiscountToInsert.vue?vue&type=template&id=7e38ede1&"
import script from "./IncomeDiscountToInsert.vue?vue&type=script&lang=js&"
export * from "./IncomeDiscountToInsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports